/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  AICreditThreshold,
  APICPUProfile,
  APIProfilingSession,
  BackOfficeSite,
  BlockContext,
  BlockReason,
  CustomDomainInfo,
  CustomHostname,
  EntityId,
  Index,
  IntegrationInstallationConfiguration,
  List,
  OrganizationBillingDateOverride,
  OrganizationBillingNumericOverride,
  OrganizationBillingOverrides,
  OrganizationCommunityType,
  OrganizationMember,
  OrganizationType,
  PercentageThreshold,
  PlainObject,
  PurgeCDNCacheContext,
  Subdomain,
  User,
  UserBackOfficeInfo,
  UserImpersonation,
} from "./data-contracts";

/**
 * @description Backoffice endpoint to update the organization-level static-IP proxy setting used by Git Sync or the integration proxy setting.
 * @tags backoffice
 * @name UpdateOrganizationIntegrationInstallationProxy
 * @summary Update the Git Sync proxy status (github or gitlab) for an organization
 * @request PATCH:/backoffice/organizations/{organizationId}/integrations/{integrationName}/network
 * @secure
 */

// @ts-ignore
export const updateOrganizationIntegrationInstallationProxy: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /**
     * Name of the integration.
     * @maxLength 100
     * @pattern ^[a-zA-Z0-9-_.]+$
     */
    integrationName: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Whether the installation should be proxied */
    proxy: boolean;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route:
    "/backoffice/organizations/{organizationId}/integrations/{integrationName}/network",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Start one hour of bounded CPU or allocation captures with GC and stall timelines on the CI-managed profiling revision. CPU is the default; allocation sampling runs separately and includes collected objects. No deployment or environment configuration is required. Returns a conflict if a session is already active.
 * @tags backoffice
 * @name CreateCpuProfilingSession
 * @summary Start an API profiling session
 * @request POST:/backoffice/debug/cpu-profile-sessions
 * @secure
 */

// @ts-ignore
export const createCPUProfilingSession: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody:
    | {
        /** @default "cpu" */
        mode?: "cpu" | "allocations";
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: APIProfilingSession;
  ResponseStatusCode: 201 | 409;
} = {
  route: "/backoffice/debug/cpu-profile-sessions",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetCpuProfilingSession
 * @summary Get an API CPU profiling session
 * @request GET:/backoffice/debug/cpu-profile-sessions/{sessionId}
 * @secure
 */

// @ts-ignore
export const getCPUProfilingSession: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** @format uuid */
    sessionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: APIProfilingSession;
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/debug/cpu-profile-sessions/{sessionId}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Profiling instances observe an explicit stop at the next session poll, nominally every ten seconds. Expiry is also enforced locally.
 * @tags backoffice
 * @name StopCpuProfilingSession
 * @summary Stop an API CPU profiling session
 * @request DELETE:/backoffice/debug/cpu-profile-sessions/{sessionId}
 * @secure
 */

// @ts-ignore
export const stopCPUProfilingSession: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** @format uuid */
    sessionId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/debug/cpu-profile-sessions/{sessionId}",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ListCpuProfiles
 * @summary List an API session's CPU profiles
 * @request GET:/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles
 * @secure
 */

// @ts-ignore
export const listCPUProfiles: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** @format uuid */
    sessionId: string;
  };
  RequestQuery: {
    /**
     * @min 0
     * @default 0
     */
    offset?: number;
    /**
     * @min 1
     * @max 100
     * @default 100
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    profiles: APICPUProfile[];
    count: number;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Return CPU or allocation stacks, GC and stall timelines with process identity. Use format=devtools to download a .cpuprofile or .heapprofile directly. Profile objects remain private and require staff authorization.
 * @tags backoffice
 * @name GetCpuProfile
 * @summary Download an API profile
 * @request GET:/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles/{profileId}
 * @secure
 */

// @ts-ignore
export const getCPUProfile: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** @format uuid */
    sessionId: string;
    /** @format uuid */
    profileId: string;
  };
  RequestQuery: {
    /**
     * Return the full diagnostic record or its raw DevTools-compatible profile.
     * @default "diagnostic"
     */
    format?: "diagnostic" | "devtools";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: IntegrationInstallationConfiguration;
  ResponseStatusCode: 200;
} = {
  route:
    "/backoffice/debug/cpu-profile-sessions/{sessionId}/profiles/{profileId}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name PurgeCloudflareCdnCache
 * @summary Purge Cloudflare's CDN cache by tags or hosts
 * @request POST:/backoffice/cdn-cache/purge
 * @secure
 */

// @ts-ignore
export const purgeCloudflareCDNCache: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody: PurgeCDNCacheContext;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/backoffice/cdn-cache/purge",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetCustomDomainInfo
 * @summary Get Custom Domain info
 * @request GET:/backoffice/custom-domains/{hostname}
 * @secure
 */

// @ts-ignore
export const getCustomDomainInfo: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: CustomDomainInfo;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/custom-domains/{hostname}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name HardDeleteCustomDomain
 * @summary Completely remove a Custom Domain from our DB and from Cloudflare
 * @request DELETE:/backoffice/custom-domains/{hostname}
 * @secure
 */

// @ts-ignore
export const hardDeleteCustomDomain: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/custom-domains/{hostname}",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name CreateCloudflareHostname
 * @summary Create Cloudflare hostname entry for the custom domain.
 * @request PUT:/backoffice/custom-domains/{hostname}/cloudflare
 * @secure
 */

// @ts-ignore
export const createCloudflareHostname: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/custom-domains/{hostname}/cloudflare",
  method: "put",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name RestartCloudflareHostnameValidation
 * @summary Restart Cloudflare hostname TLS validation for the custom domain.
 * @request PATCH:/backoffice/custom-domains/{hostname}/cloudflare
 * @secure
 */

// @ts-ignore
export const restartCloudflareHostnameValidation: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The custom hostname, for example "docs.gitbook.com" */
    hostname: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/custom-domains/{hostname}/cloudflare",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name BlockPublicContentUrls
 * @summary Block public content by a list of public URLs
 * @request POST:/backoffice/blocks/public-urls
 * @secure
 */

// @ts-ignore
export const blockPublicContentUrls: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {};
  RequestQuery: {};
  RequestBody:
    | string[]
    | {
        /** A short description giving context on the reason for the block. */
        reason: BlockReason;
        /** @minItems 1 */
        urls: string[];
      };
  RequestHeaders: {};
  ResponseBody: {
    blocked: string[];
    failed: {
      url?: string;
      reason?: string;
    }[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/blocks/public-urls",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetUserBackOfficeInfo
 * @summary Get the GitBook User info shown in the BackOffice
 * @request GET:/backoffice/users/{userId}
 * @secure
 */

// @ts-ignore
export const getUserBackOfficeInfo: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: UserBackOfficeInfo;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ResetMfa
 * @summary Reset a user's MFA
 * @request DELETE:/backoffice/users/{userId}/mfa
 * @secure
 */

// @ts-ignore
export const resetMFA: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/users/{userId}/mfa",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name BlockUser
 * @summary Block or Unblock a User
 * @request PATCH:/backoffice/users/{userId}/block
 * @secure
 */

// @ts-ignore
export const blockUser: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: BlockContext;
  RequestHeaders: {};
  ResponseBody: UserBackOfficeInfo;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}/block",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ImpersonateUser
 * @summary Impersonate a User
 * @request POST:/backoffice/users/{userId}/impersonate
 * @secure
 */

// @ts-ignore
export const impersonateUser: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: UserImpersonation;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}/impersonate",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name UserPermissions
 * @summary Returns user permissions
 * @request GET:/backoffice/users/{userId}/permissions
 * @secure
 */

// @ts-ignore
export const userPermissions: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique ID of the User */
    userId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Index;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/users/{userId}/permissions",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice, organizations
 * @name GetHideTrademarkForOrganizationById
 * @summary Get the hide trademark flag for an organization
 * @request GET:/backoffice/organizations/{organizationId}/trademark
 * @secure
 */

// @ts-ignore
export const getHideTrademarkForOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    hideTrademark: boolean;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/organizations/{organizationId}/trademark",
  method: "get",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice, organizations
 * @name ToggleHideTrademarkForOrganizationById
 * @summary Hide trademark or show it for an organization
 * @request PATCH:/backoffice/organizations/{organizationId}/trademark
 * @secure
 */

// @ts-ignore
export const toggleHideTrademarkForOrganizationById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    hideTrademark: boolean;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/organizations/{organizationId}/trademark",
  method: "patch",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name BlockOrganization
 * @summary Block or Unblock an Organization
 * @request PATCH:/backoffice/organizations/{organizationId}/block
 * @secure
 */

// @ts-ignore
export const blockOrganization: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: BlockContext;
  RequestHeaders: {};
  ResponseBody: {
    /** Whether the organization is blocked */
    blocked: boolean;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/block",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name SwitchOrganizationType
 * @summary Switch an Organization from Paid to Community or vice-versa
 * @request PATCH:/backoffice/organizations/{organizationId}/switch
 * @secure
 */

// @ts-ignore
export const switchOrganizationType: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody:
    | {
        type: "community";
        communityType: OrganizationCommunityType;
      }
    | {
        type: "business";
      };
  RequestHeaders: {};
  ResponseBody: {
    type: OrganizationType;
    communityType?: OrganizationCommunityType;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/switch",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Start a trial for an organization for a given number of days. Backoffice-only.
 * @tags backoffice, organizations
 * @name StartTrial
 * @summary Start a trial for an organization
 * @request POST:/backoffice/organizations/{organizationId}/trial
 * @secure
 */

// @ts-ignore
export const startTrial: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /**
     * Number of days for the trial period
     * @min 1
     */
    days: number;
    /** Force starting a trial even if an active subscription exists */
    force?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route: "/backoffice/organizations/{organizationId}/trial",
  method: "post",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Get Stripe customer metadata billing overrides for an organization. Backoffice-only.
 * @tags backoffice, organizations
 * @name GetOrganizationBillingOverrides
 * @summary Get billing overrides for an organization
 * @request GET:/backoffice/organizations/{organizationId}/billing-overrides
 * @secure
 */

// @ts-ignore
export const getOrganizationBillingOverrides: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationBillingOverrides;
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/billing-overrides",
  method: "get",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Set or unset Stripe customer metadata billing overrides for an organization. Backoffice-only.
 * @tags backoffice, organizations
 * @name UpdateOrganizationBillingOverrides
 * @summary Update billing overrides for an organization
 * @request PATCH:/backoffice/organizations/{organizationId}/billing-overrides
 * @secure
 */

// @ts-ignore
export const updateOrganizationBillingOverrides: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Set to true for an indefinite override, to a timestamp for a dated override, or to null to unset. */
    frozenInterval?: OrganizationBillingDateOverride | null;
    /** Set to true for an indefinite override, to a timestamp for a dated override, or to null to unset. */
    enableSAML?: OrganizationBillingDateOverride | null;
    /** Set an Enterprise organization's contractual AI credit allowance, or null to unset. */
    aiCreditAllowance?: OrganizationBillingNumericOverride | null;
    /** Set the percentage of paid AI credits carried into the next billing period, or null to use the 50% default for paid organizations. Set to 0 to disable rollover. */
    aiCreditRollover?: PercentageThreshold;
    /** Set the percentage of total AI credits remaining at which to send a low-balance alert, or null to disable the alert. */
    aiCreditAlertThreshold?: AICreditThreshold;
    /** Whether AI features pause automatically once all AI credits are used, before usage is billed as overage. */
    aiCreditPauseEnabled?: boolean;
    /** Set to false to force AI off as the organization's contract requires, or to null to unset. */
    hasAI?: false | null;
    /** Set to an integer numeric override, or to null to unset. */
    minUsers?: OrganizationBillingNumericOverride | null;
    /** Set to an integer numeric override, or to null to unset. */
    maxUsers?: OrganizationBillingNumericOverride | null;
    /** Set to an integer numeric override, or to null to unset. */
    minPremiumSites?: OrganizationBillingNumericOverride | null;
    /** Set to an integer numeric override, or to null to unset. */
    maxPremiumSites?: OrganizationBillingNumericOverride | null;
    /** Set to an integer numeric override, or to null to unset. */
    minUltimateSites?: OrganizationBillingNumericOverride | null;
    /** Set to an integer numeric override, or to null to unset. */
    maxUltimateSites?: OrganizationBillingNumericOverride | null;
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/backoffice/organizations/{organizationId}/billing-overrides",
  method: "patch",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Backoffice-only migration of existing organization SSO users from old emails to new emails.
 * @tags backoffice, organizations
 * @name MigrateSsoEmails
 * @summary Migrate organization SSO emails
 * @request POST:/backoffice/organizations/{organizationId}/sso-email-migration
 * @secure
 */

// @ts-ignore
export const migrateSSOEmails: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** @minItems 1 */
    migrations: {
      /** @format email */
      fromEmail: string;
      /** @format email */
      toEmail: string;
    }[];
  };
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 400 | 404 | 409;
} = {
  route: "/backoffice/organizations/{organizationId}/sso-email-migration",
  method: "post",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Backoffice-only preflight for an organization SSO email migration.
 * @tags backoffice, organizations
 * @name PreviewSsoEmailMigration
 * @summary Preview organization SSO email migration
 * @request POST:/backoffice/organizations/{organizationId}/sso-email-migration/preview
 * @secure
 */

// @ts-ignore
export const previewSSOEmailMigration: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** @minItems 1 */
    migrations: {
      /** @format email */
      fromEmail: string;
      /** @format email */
      toEmail: string;
    }[];
  };
  RequestHeaders: {};
  ResponseBody: {
    organization: string;
    entries: {
      /** @format email */
      fromEmail: string;
      /** @format email */
      toEmail: string;
      status: "ready" | "blocked";
      issues: (
        | "same_email"
        | "source_email_not_found"
        | "source_email_used_by_multiple_mappings"
        | "source_user_not_org_sso"
        | "source_user_not_org_member"
        | "target_email_already_used"
        | "target_email_used_by_non_org_sso_user"
        | "target_email_used_by_multiple_mappings"
      )[];
      sourceUser: User | null;
      sourceMember: OrganizationMember | null;
      sourceAuthSSO?: string;
      sourceProfileSSO?: string;
      sourceOrganizationSSO: boolean;
      targetUser: User | null;
      targetMember: OrganizationMember | null;
      targetAuthSSO?: string;
      targetProfileSSO?: string;
      targetOrganizationSSO: boolean;
    }[];
    /** Target-email users that block migration and are not tied to the organization through SSO. */
    duplicateUsers: User[];
    summary: {
      total: number;
      ready: number;
      blocked: number;
      duplicates: number;
      canMigrate: boolean;
    };
  };
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route:
    "/backoffice/organizations/{organizationId}/sso-email-migration/preview",
  method: "post",
  streaming: false,
  tags: ["backoffice", "organizations"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ListCustomHostnamesForOrganizationById
 * @summary List active and deprecated Custom Domains for an organization
 * @request GET:/backoffice/organizations/{organizationId}/custom-hostnames
 * @secure
 */

// @ts-ignore
export const listCustomHostnamesForOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: CustomHostname[];
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/organizations/{organizationId}/custom-hostnames",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ListSubdomainsForOrganizationById
 * @summary List active and deprecated subdomains for an organization
 * @request GET:/backoffice/organizations/{organizationId}/subdomains
 * @secure
 */

// @ts-ignore
export const listSubdomainsForOrganizationById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Subdomain[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/organizations/{organizationId}/subdomains",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name PurgeOpenApiSpecs
 * @summary Purge the cache for all OpenAPI specs associated to an organization
 * @request DELETE:/backoffice/organizations/{organizationId}/openapi/cache
 * @secure
 */

// @ts-ignore
export const purgeOpenApiSpecs: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/backoffice/organizations/{organizationId}/openapi/cache",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name UnblockSpace
 * @summary Unblock a Space
 * @request PATCH:/backoffice/spaces/{spaceId}/block
 * @secure
 */

// @ts-ignore
export const unblockSpace: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: BlockContext;
  RequestHeaders: {};
  ResponseBody: {
    /** Whether the space is blocked */
    blocked: boolean;
  };
  ResponseStatusCode: 200;
} = {
  route: "/backoffice/spaces/{spaceId}/block",
  method: "patch",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name PurgeSpaceCache
 * @summary Purge the cache for a single space
 * @request DELETE:/backoffice/spaces/{spaceId}/cache
 * @secure
 */

// @ts-ignore
export const purgeSpaceCache: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/spaces/{spaceId}/cache",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ReindexSpaceContentSearch
 * @summary Run a health check on the indexation of a space in the search engine. Run an indexation if needed.
 * @request POST:/backoffice/spaces/{spaceId}/content/index/search
 * @secure
 */

// @ts-ignore
export const reindexSpaceContentSearch: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/spaces/{spaceId}/content/index/search",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name ReindexSpaceContentAi
 * @summary Run an indexation of the content into the vector DB.
 * @request POST:/backoffice/spaces/{spaceId}/content/index/vectors
 * @secure
 */

// @ts-ignore
export const reindexSpaceContentAI: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/backoffice/spaces/{spaceId}/content/index/vectors",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name GetSiteBackOfficeInfo
 * @summary Get a site by its ID with no organization ID
 * @request GET:/backoffice/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const getSiteBackOfficeInfo: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BackOfficeSite;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/backoffice/sites/{siteId}",
  method: "get",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags backoffice
 * @name PurgeSiteCache
 * @summary Purge a site's cache
 * @request DELETE:/backoffice/sites/{siteId}/cache
 * @secure
 */

// @ts-ignore
export const purgeSiteCache: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/backoffice/sites/{siteId}/cache",
  method: "delete",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description This endpoint is available for sites with Visitor Authentication (VA) enabled, and for adaptive content sites. Adaptive content sites can optionally provide visitor claims to be embedded in the generated token.
 * @tags backoffice
 * @name GetSiteVisitorAuthToken
 * @summary Get a site visitor auth token
 * @request POST:/backoffice/sites/{siteId}/auth/token
 * @secure
 */

// @ts-ignore
export const getSiteVisitorAuthToken: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody:
    | {
        visitorSignedClaims?: PlainObject;
      }
    | undefined;
  RequestHeaders: {};
  ResponseBody: {
    token: string;
  };
  ResponseStatusCode: 200 | 400;
} = {
  route: "/backoffice/sites/{siteId}/auth/token",
  method: "post",
  streaming: false,
  tags: ["backoffice"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
